import React, { useEffect, useState } from 'react';
import ModalForm from '../../../../components/modalComponents/ModalForm';
import InputText from '../../../../components/modalComponents/InputText';
import InputDate from '../../../../components/modalComponents/InputDate';
import { useManageGetRequest } from '../../../../hooks/useManageGetRequest/useManageGetRequest';
import { useManagePostRequest } from '../../../../hooks/useManagePostRequest/useManagePostRequest';
import { aprobarRechazarSolicitudBonoTutoriaAPI, buscarColaboradorBonoTutoriaAPI } from '../../../../consumers/backendApisUrls';
import SelectInput from '../../../../components/Select/SelectInput';
import ActionGenericModal from '../../../../components/modal/ActionGenericModal';
import ModalEnabled from '../../../../components/modalComponents/ModalEnabled';
import RechazarSolicitud from './RechazarSolicitud';

const BaseSolicitudes = ({ IdSolicitudBonoTutoria,
    toggleModal,
    handleSubmit,
    title,
    sectionName,
    formValues,
    setFormValues,
    commonProps,
    KEYS,
    nuevo,
    CampanaBonoTutoria,
    successSubmit,
    fechasTutoria
}
) => {
    const SECTION_NAME = sectionName;
    const [executePost] = useManagePostRequest();
    const [criterio, setCriterio] = useState("");
    const [opciones, setOpciones] = useState([]);
    const [cargando, setCargando] = useState(false);
    const [selectedValue, setSelectedValue] = useState(null);
    const [modalEnabled, setModalEnabled] = useState({
        isEnable: false,
        component: React.Fragment,
    });
    const MIN_CARACTERES = 2;
    const buscarColaboradores = async () => {
        if (criterio.length < MIN_CARACTERES) return;
        setCargando(true);
        setFormValues(initialFormValues)
        setSelectedValue(null);
        setOpciones([]);
        const payload = {
            "Criteria": criterio
        }
        try {
            await executePost(buscarColaboradorBonoTutoriaAPI(), payload, successManageSearchEmpleadoCallback);
        } catch (error) {
            console.error("Error buscando colaboradores:", error);
        } finally {
            setCargando(false);
        }
    };
    const successManageSearchEmpleadoCallback = ({ data }) => {
        const mapped = (data ?? []).map(item => ({
            value: item.IdEmpleado,
            label: item.FullName,
            original: item
        }));
        setOpciones(mapped ?? []);

    }
    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            buscarColaboradores();
        }, 400);
        return () => clearTimeout(delayDebounce);
    }, [criterio]);

    const initialFormValues = {
        [KEYS.IdEmpleado]: "",
        [KEYS.NombreCompleto]: "",
        [KEYS.Cargo]: "",
        [KEYS.NombreSede]: "",
        [KEYS.CampanaBonoTutoria]: CampanaBonoTutoria?.label
    };
    useEffect(() => {
        if (!selectedValue) return;
        const emp = selectedValue.original;
        if (!emp) return;
        setFormValues(prev => ({
            ...prev,
            [KEYS.IdEmpleado]: emp.IdEmpleado,
            [KEYS.NombreCompleto]: emp.FullName,
            [KEYS.Cargo]: emp.Cargo,
            [KEYS.NombreSede]: emp.Sede,
            [KEYS.CampanaBonoTutoria]: CampanaBonoTutoria?.label,
            [KEYS.FechaIngresoTrabajo]: emp.FechaIngresoTrabajo
        }));
    }, [selectedValue]);

    const handleActionRow = ({ row, api, title, actionLabel }) => {
        const payload = { IdSolicitudBeneficio: row, RechazarSolicitud: true, MotivoRechazo: 'prueba' };
        const data = {
            api,
            title,
            actionLabel,
            payload,
            name: `${row}, con Monto: ${row}`
        };
        setModalEnabled({ isEnable: true, component: ActionGenericModal, data });
    }

    const formatDate = (isoDate) => {
        if (!isoDate) return "";
        const date = new Date(isoDate);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };


    return (
        <><ModalEnabled
            modalEnabled={modalEnabled}
            setModalEnabled={setModalEnabled}
            refreshPage={successSubmit}
        />
            <ModalForm
                onSubmit={handleSubmit}
                showModal={toggleModal}
                saveButtonDisabled={!formValues[KEYS.PuedeEditar]}
                width="1200px"
                titulo={title}>
                <div className="row">
                    {nuevo &&
                        <div className="col-sm-6">
                            <InputText
                                type="text"
                                className="form-control"
                                placeholder="Nombre, Apellidos, DNI"
                                value={criterio}
                                onChange={(e) => setCriterio(e.target.value)}
                            />

                            {cargando && (
                                <span style={{ marginLeft: 10 }}>
                                    Cargando...
                                </span>
                            )}
                        </div>}
                    {nuevo &&
                        <div className="col-md-6">
                            <SelectInput
                                options={opciones}
                                jsonSelectedValue={selectedValue}
                                setJsonSelectedValue={setSelectedValue}
                                placeholder="Seleccione un colaborador"
                                isDisabled={cargando}
                            />
                        </div>}
                    <div className="col-md-2">
                        <InputText
                            label="Codigo Trabajador"
                            {...commonProps(KEYS.IdEmpleado)}
                            isDisabled={true}
                            direction="column"
                        />
                    </div>
                    <div className="col-md-6">
                        <InputText
                            label="Nombres y Apellidos"
                            {...commonProps(KEYS.NombreCompleto)}
                            isDisabled={true}
                            direction="column"
                        />
                    </div>
                    <div className="col-md-4">
                        <InputText
                            label="Cargo"
                            {...commonProps(KEYS.Cargo)}
                            isDisabled={true}
                            direction="column"
                        />
                    </div>
                    <div className="col-md-4">
                        <InputDate
                            label="Fecha de ingreso"
                            {...commonProps(KEYS.FechaIngresoTrabajo)}
                            isDisabled={true}
                            direction="column"
                        />
                    </div>
                    <div className="col-md-4">
                        <InputText
                            label="Sede"
                            {...commonProps(KEYS.NombreSede)}
                            isDisabled={true}
                            direction="column"
                        />
                    </div>
                    <div className="col-md-4">
                        <InputText
                            label="Campaña"
                            {...commonProps(KEYS.CampanaBonoTutoria)}
                            isDisabled={true}
                            direction="column"
                        />
                    </div>
                    <div className="col-md-6">
                        <InputDate
                            label="Fecha Inicio Tutoria"
                            {...commonProps(KEYS.FechaTutorInicio)}
                            isDisabled={!formValues[KEYS.PuedeEditar]}
                            min={fechasTutoria?.FechaTutoriaInicio}
                            max={fechasTutoria?.FechaTutoriaFin}
                            direction="column"
                        />
                    </div>
                    <div className="col-md-6">
                        <InputDate
                            label="Fecha Fin Tutoria"
                            isDisabled={!formValues[KEYS.PuedeEditar]}
                            min={fechasTutoria?.FechaTutoriaInicio}
                            max={fechasTutoria?.FechaTutoriaFin}
                            {...commonProps(KEYS.FechaTutorFin)}
                            direction="column"
                        />
                    </div>

                </div>
                <div className="modal-footer justify-content-end">
                    <div className="d-flex justify-content-center align-items-center" style={{ gap: "10px" }}>
                        {formValues[KEYS.PuedeEditar] && formValues[KEYS.EstadoRegistro] !='Aprobado' &&  !nuevo && <button type='button' className='btn generic-button-buscador generic-button-hover-verde'
                            onClick={() => setModalEnabled(
                                {
                                    isEnable: true, component: ActionGenericModal,
                                    data: {
                                        title: "Aprobar", actionLabel: "aprobar",
                                        api: aprobarRechazarSolicitudBonoTutoriaAPI,
                                        name: `${formValues[KEYS.NombreCompleto]}: ${formatDate(formValues[KEYS.FechaTutorInicio])} -  ${formatDate(formValues[KEYS.FechaTutorFin])}`, item: "registro", payload: { IdSolicitudBonoTutoria: IdSolicitudBonoTutoria, AprobarSolicitud: true }
                                    }
                                })}>
                            Aprobar
                        </button>
                        }
                        {formValues[KEYS.PuedeEditar] && formValues[KEYS.EstadoRegistro] !='Rechazado' && !nuevo &&
                            <button type='button' className='btn generic-button-buscador generic-button-hover-rojo'
                                onClick={() =>
                                    setModalEnabled({
                                        isEnable:true, component: RechazarSolicitud, 
                                        data:{
                                            title:"Rechazar Solicitud", actionLabel:"Rechazar", api: aprobarRechazarSolicitudBonoTutoriaAPI,
                                            name: `${formValues[KEYS.NombreCompleto]}: ${formatDate(formValues[KEYS.FechaTutorInicio])} -  ${formatDate(formValues[KEYS.FechaTutorFin])}`, item: "registro", payload: { IdSolicitudBonoTutoria: IdSolicitudBonoTutoria, RechazarSolicitud: true }
                                        }
                                    })
                                }
                            >
                                Rechazar
                            </button>
                        }
                    </div>
                </div>
            </ModalForm>
        </>
    );

}

export default BaseSolicitudes;